import { deepIntro, timeline } from '@/mocks/home';

export default function Timeline() {
  return (
    <section id="timeline" className="mx-auto max-w-6xl scroll-mt-16 px-4 py-10 md:px-6 md:py-14">
      <div className="grid gap-6 lg:grid-cols-[0.9fr_1.1fr] lg:gap-8">
        {/* intro + cover */}
        <div className="flex flex-col justify-between overflow-hidden rounded-lg border border-secondary-200 bg-foreground-950 text-background-100">
          <div className="relative h-52 w-full md:h-60">
            <img
              src="https://readdy.ai/api/search-image?query=chronological%20investigation%20sketch%20with%20paper%20index%20cards%20and%20red%20numbered%20arrows%20arranged%20in%20sequence%20on%20dark%20desk%2C%20warm%20amber%20light%2C%20crimson%20and%20gold%20tones%2C%20noir%20editorial%20photography%2C%20film%20grain%2C%20high%20contrast%2C%20orderly%20yet%20moody%20documentary%20composition%20without%20blue%20or%20purple&width=720&height=420&seq=timeline-cover&orientation=landscape"
              alt="深扒顺序整理封面"
              title="深扒脉络 时间线整理"
              className="h-full w-full object-cover object-center"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/80 to-transparent" />
            <span className="absolute left-4 top-4 inline-flex items-center gap-1 rounded-sm bg-accent-500 px-2 py-1 text-xs font-bold text-foreground-950">
              <i className="ri-node-tree" />
              FEATURED
            </span>
          </div>
          <div className="flex flex-1 flex-col p-6">
            <span className="text-stamp text-xs text-accent-300">DEEP DIVE</span>
            <h3 className="font-heading mt-2 text-2xl font-black text-background-50">
              {deepIntro.title}
            </h3>
            <p className="mt-3 text-sm leading-relaxed text-background-200">{deepIntro.text}</p>
            <a
              href="#index"
              className="mt-6 inline-flex w-fit items-center gap-1 whitespace-nowrap rounded-md bg-accent-500 px-5 py-2.5 text-sm font-bold text-foreground-950 hover:bg-accent-400"
            >
              从索引开始按顺序查证
              <i className="ri-arrow-right-line" />
            </a>
          </div>
        </div>

        {/* steps */}
        <div className="flex flex-col gap-3">
          {timeline.map((t, i) => (
            <article
              key={t.step}
              className="flex gap-4 rounded-lg border border-secondary-200 bg-background-50 p-4 md:p-5"
            >
              <div className="flex flex-col items-center">
                <span className="font-heading flex h-11 w-11 items-center justify-center rounded-md bg-primary-500 text-base font-black text-background-50">
                  {String(i + 1).padStart(2, '0')}
                </span>
                {i < timeline.length - 1 && (
                  <span className="mt-1 w-px flex-1 bg-secondary-300" />
                )}
              </div>
              <div className="min-w-0 flex-1">
                <div className="flex flex-wrap items-center gap-2">
                  <span className="whitespace-nowrap rounded-sm bg-primary-100 px-2 py-0.5 text-xs font-medium text-primary-800">
                    {t.time}
                  </span>
                  <span className="whitespace-nowrap text-xs text-foreground-400">{t.step}</span>
                </div>
                <h4 className="mt-2 text-base font-bold text-foreground-950">{t.title}</h4>
                <p className="mt-1 text-sm leading-relaxed text-foreground-600">{t.detail}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}